import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { Form, Field } from 'simple-react-form'
import KycCheckbox from 'App/components/fields/KycCheckbox'
import styles from './styles.css'
import { originOfFunds, formValidation } from './formData'
import Button from '@orionx-dev/orionsoft-parts/lib/components/Button'
import setGraphQLErrors from '@orionx-dev/orionsoft-parts/lib/helpers/setGraphQLErrors'
import { KycContext } from 'App/KYC/Layout'
import useMessage from 'App/hooks/useMessage'

const FundsOrigin = ({ callNextStep, callBackStep }) => {
  const showMessage = useMessage()
  const { kyc, setKyc } = useContext(KycContext)

  const [form, setForm] = useState({ fundsOrigin: [] })

  const isFormValidCheck = values => {
    return formValidation.every(field => field.isValid(values[field.fieldName]))
  }

  const save = async () => {
    try {
      const valid = isFormValidCheck(form)

      if (!valid) {
        showMessage('Valor incorrecto en formulario')
        return
      }

      setKyc({
        ...kyc,
        missingInfo: {
          ...kyc.missingInfo,
          ...form,
        },
      })
      callNextStep(true, true)
    } catch (error) {
      console.error(error)
      setGraphQLErrors(error)
    }
  }

  return (
    <Form className={styles.form} state={form} onChange={setForm}>
      <div>
        <div className={styles.sectionTitle}>
          <h1>Selecciona de dónde provienen tus ingresos</h1>
        </div>
        <div className={styles.container}>
          <Field fieldName="fundsOrigin" type={KycCheckbox} options={originOfFunds} />
        </div>
        <div className={styles.submit}>
          <Button className={styles.buttonOutline} onClick={callBackStep}>
            Atrás
          </Button>
          <Button onClick={save} className={styles.buttonPrimary}>
            Siguiente
          </Button>
        </div>
      </div>
    </Form>
  )
}

FundsOrigin.propTypes = {
  callNextStep: PropTypes.func,
  callBackStep: PropTypes.func,
}

export default FundsOrigin
